import styled from '@emotion/styled';
import { useEffect } from 'react';

const Blockchain = ({ step }: { step: number }): JSX.Element => {
  useEffect(() => {
    if (![2, 3].includes(step)) return;

    const circles = document.querySelectorAll('.circles .circle');
    const lines = document.querySelectorAll('.lines .line');
    const icons = document.querySelectorAll('.block_icon');

    const lenCircles = circles.length;
    const lenLines = lines.length;
    const lenIcons = icons.length;

    setTimeout(() => {
      let temp = 0;
      for (let idx = 0; idx < lenCircles; idx++) {
        if (idx % 5 === 0) {
          temp = idx + 5;
        }

        if (idx <= temp) {
          circles[idx].animate(
            [
              { transform: `rotate(${120}deg)`, opacity: 0 },
              { transform: `rotate(${0}deg)`, opacity: 1 },
            ],
            {
              // timing options
              delay: 100 * Math.floor(idx / 20),
              duration: 2000,
              fill: 'forwards',
              easing: 'ease-out',
            },
          );
        }
      }
    });

    setTimeout(() => {
      for (let idx = 0; idx < lenIcons; idx++) {
        icons[idx].animate([{ opacity: 0 }, { opacity: 1 }], {
          // timing options
          delay: Math.floor(lenCircles / 20) * 1000,
          duration: 2000,
          fill: 'forwards',
          easing: 'ease-out',
        });
      }
    });

    let isBackground = false;
    for (let idx = 0; idx < lenLines; idx++) {
      isBackground =
        !!lines[idx].parentElement?.classList.contains('background');

      lines[idx].animate(
        [
          {
            strokeDashoffset: 1000,
            opacity: 0,
          },
          {
            strokeDashoffset: 0,
            opacity: isBackground ? 0.4 : 0.8,
          },
        ],
        {
          // timing options
          easing: 'ease-out',
          duration: isBackground ? 3000 : 2000,
          delay: 1000 + idx * 10,
          fill: 'forwards',
        },
      );
    }
  }, [step]);

  return (
    <Wrap>
      {[2, 3].includes(step) && (
        <div className={step === 3 ? 'zoom_out' : ''}>
          <svg
            id="node_sphere"
            width="449"
            height="455"
            viewBox="0 0 449 455"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g className="lines">
              <g className="background">
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M135.909 49.8545L105.618 166.606"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M105.024 166.436L192.588 99.2363"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M192.588 99.2363L135.909 49.8545"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M228.054 31.6121L192.164 99.0666"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M192.164 99.0666L270.903 40.2666"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M270.903 40.2666L254.782 153.03"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M254.782 153.03L192.164 99.0667"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M254.442 152.776L338.103 64.2787"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M270.903 40.2666L356.431 174.751"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M372.552 129.358L356.431 174.667"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M299.243 265.115L437.8 250.606"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M299.158 265.624L356.43 174.667"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M254.782 153.03L356.345 174.412"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M254.697 152.945L299.158 265.709"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M299.158 265.624L170.103 210.982"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M170.358 211.067L255.037 153.03"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M170.358 211.067L192.588 99.2363"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M170.358 211.151L104.939 166.012"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M105.364 166.352L53.4365 133.6"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M105.024 166.436L20.8545 244.242"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M104.939 166.012L70.5757 302.109"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M70.5759 302.109L20.2607 246.533"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M50.7212 337.745L70.5757 302.109"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M71 302.024L139.727 382.206"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M139.643 382.63L74.8184 368.036"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M139.643 382.63L128.019 419.2"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M139.728 382.63L191.485 439.479"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M191.74 438.8L303.485 336.303"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M303.146 336.133L317.909 429.467"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M303.061 335.879L395.97 353.697"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M303.061 335.879L437.715 249.927"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M299.158 265.709L303.061 335.879"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M303.4 335.964L157.8 298.46"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M303.061 335.879L139.473 382.46"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M139.473 382.461L157.545 298.715"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M157.8 298.46L70.7456 301.77"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M157.546 298.715L105.534 166.861"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M170.188 211.491L157.8 298.461"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M157.8 298.46L299.158 265.709"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M356.6 174.836L437.715 249.927"
                  stroke="#E8E8E8"
                />
                <path
                  className="line"
                  opacity="0.45"
                  strokeWidth="0.5"
                  d="M191.485 439.479L318.079 429.721"
                  stroke="#E8E8E8"
                />
              </g>
              <g className="content">
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M228.055 31.6121L270.479 39.5878"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M269.63 39.8424L305.521 125.624"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M305.182 125.709L165.606 110.521"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M269.63 39.8424L166.2 110.861"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M269.63 39.8424L372.891 130.036"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M372.976 129.782L338.103 64.2787"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M338.103 64.2788L269.63 39.8424"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M338.103 64.2787L396.224 122.145"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M395.885 121.806L372.891 130.036"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M395.885 121.806L413.958 150.994"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M413.958 151.079L372.976 129.782"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M372.891 130.036L437.715 249.927"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M437.715 249.927L413.618 151.333"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M437.715 249.927L383.158 248.485"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M372.891 130.036L383.158 248.994"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M383.158 248.485L395.97 353.697"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M395.63 354.461L437.715 249.927"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M395.63 354.461L293.812 383.139"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M293.812 383.139L383.158 248.485"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M293.643 382.97L318.418 429.467"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M318.079 429.721L227.885 444.57"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M227.885 444.145L191.485 439.479"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M192.418 439.818L293.812 383.139"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M293.812 383.139L160.431 363.2"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M161.958 363.454L192.418 439.818"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M162.212 363.37L230.855 246.533"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M230.854 246.533L293.982 382.545"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M230.854 246.533L383.158 248.485"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M305.182 125.709L231.279 246.448"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M383.158 248.994L305.691 126.048"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M166.2 110.861L230.43 245.685"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M230.855 247.042L85.7637 246.533"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M85.7637 246.533L165.861 110.182"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M85.7638 246.533L74.8184 368.036"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M74.8184 368.036L128.018 419.2"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M128.019 419.2L192.419 439.818"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M191.739 438.8L74.6484 366.764"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M50.7212 337.745L74.8182 368.036"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M74.8183 368.036L20.2607 246.024"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M50.8909 337.491L20.5151 246.618"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M20.2607 246.533L57.9335 140.642"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M57.5942 141.236L86.1033 246.109"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M57.5942 141.236L165.776 110.691"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M135.824 49.0908L165.776 110.691"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M135.824 49.6L57.9336 140.642"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M57.5939 141.236L42.2363 157.018"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M42.2363 157.018L53.4363 133.6"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M42.2365 157.018L20.2607 246.024"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M53.4365 133.6L135.824 49.6"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M135.824 49.6L269.63 39.8424"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M227.885 31.5272L136.249 49.4303"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M85.7637 246.533L161.958 363.455"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M75.3276 367.357L162.128 363.539"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M305.182 125.709L372.891 130.036"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M318.079 429.721L395.631 354.461"
                  stroke="#E8E8E8"
                />
                <path
                  opacity="0.7"
                  strokeWidth="0.7"
                  className="line"
                  d="M20.2607 246.533L86.1032 247.212"
                  stroke="#E8E8E8"
                />
              </g>
            </g>
            <g className="circles">
              <g className="circle">
                <path
                  opacity="0.5"
                  d="M242.997 247.86C243.943 241.249 239.396 235.116 232.842 234.162C226.288 233.208 220.209 237.794 219.263 244.406C218.317 251.017 222.864 257.15 229.418 258.104C235.972 259.058 242.052 254.472 242.997 247.86Z"
                  fill="white"
                />
                <path
                  d="M236.388 240.816C239.297 243.75 239.297 248.506 236.388 251.439C233.48 254.373 228.765 254.373 225.857 251.439C222.949 248.506 222.949 243.75 225.857 240.816C228.765 237.882 233.48 237.882 236.388 240.816Z"
                  fill="white"
                  stroke="#CA8BE9"
                />
              </g>

              <path
                className="circle"
                d="M309.212 125.641C309.212 126.376 308.996 127.093 308.592 127.703C308.188 128.312 307.615 128.787 306.945 129.067C306.275 129.347 305.537 129.42 304.826 129.277C304.115 129.135 303.461 128.782 302.948 128.264C302.434 127.746 302.084 127.085 301.942 126.365C301.8 125.645 301.873 124.899 302.151 124.221C302.429 123.544 302.9 122.965 303.504 122.558C304.108 122.151 304.817 121.934 305.542 121.934C306.514 121.934 307.447 122.324 308.135 123.019C308.824 123.713 309.212 124.657 309.212 125.641Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <g className="circle">
                <path
                  opacity="0.5"
                  d="M311.838 125.641C311.836 126.901 311.464 128.133 310.768 129.179C310.073 130.226 309.085 131.041 307.931 131.522C306.776 132.003 305.506 132.128 304.281 131.881C303.056 131.633 301.931 131.026 301.049 130.134C300.166 129.242 299.565 128.106 299.322 126.87C299.079 125.634 299.205 124.353 299.684 123.189C300.162 122.025 300.972 121.031 302.011 120.331C303.05 119.631 304.271 119.257 305.52 119.257C306.35 119.257 307.173 119.423 307.94 119.743C308.707 120.064 309.404 120.535 309.991 121.128C310.578 121.721 311.043 122.425 311.36 123.199C311.677 123.974 311.839 124.803 311.838 125.641Z"
                  fill="white"
                />
                <path
                  d="M170.061 111.217C170.061 111.951 169.845 112.669 169.441 113.278C169.037 113.888 168.464 114.363 167.793 114.643C167.123 114.923 166.386 114.996 165.675 114.853C164.964 114.71 164.31 114.358 163.796 113.84C163.283 113.322 162.932 112.661 162.79 111.941C162.648 111.221 162.721 110.475 163 109.797C163.278 109.119 163.749 108.541 164.353 108.134C164.956 107.727 165.665 107.51 166.39 107.51C167.362 107.51 168.295 107.9 168.984 108.594C169.673 109.289 170.061 110.233 170.061 111.217Z"
                  fill="white"
                  stroke="#CA8BE9"
                />
              </g>
              <g className="circle">
                <path
                  opacity="0.5"
                  d="M172.687 111.217C172.685 112.477 172.312 113.708 171.617 114.755C170.921 115.802 169.934 116.617 168.779 117.098C167.625 117.579 166.354 117.704 165.13 117.456C163.905 117.209 162.78 116.601 161.897 115.71C161.015 114.818 160.414 113.682 160.171 112.446C159.928 111.21 160.054 109.929 160.532 108.765C161.011 107.601 161.821 106.606 162.859 105.907C163.898 105.207 165.119 104.833 166.369 104.833C167.199 104.833 168.022 104.998 168.789 105.319C169.556 105.64 170.253 106.111 170.84 106.704C171.427 107.297 171.892 108 172.209 108.775C172.526 109.549 172.688 110.379 172.687 111.217Z"
                  fill="white"
                />
                <path
                  d="M86.1028 252.133C88.8208 252.133 91.0241 249.93 91.0241 247.212C91.0241 244.494 88.8208 242.291 86.1028 242.291C83.3849 242.291 81.1816 244.494 81.1816 247.212C81.1816 249.93 83.3849 252.133 86.1028 252.133Z"
                  fill="white"
                  stroke="#CA8BE9"
                />
              </g>
              <path
                className="circle"
                d="M165.818 363.217C165.818 363.951 165.602 364.669 165.198 365.278C164.794 365.888 164.221 366.363 163.551 366.643C162.881 366.923 162.143 366.996 161.432 366.853C160.721 366.71 160.067 366.358 159.554 365.84C159.04 365.322 158.69 364.661 158.548 363.941C158.406 363.221 158.479 362.475 158.757 361.797C159.035 361.119 159.506 360.541 160.11 360.134C160.713 359.727 161.423 359.51 162.148 359.51C163.12 359.51 164.053 359.9 164.741 360.594C165.43 361.289 165.818 362.233 165.818 363.217Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <g className="circle">
                <path
                  opacity="0.5"
                  d="M168.444 363.217C168.442 364.477 168.07 365.708 167.374 366.755C166.679 367.802 165.691 368.617 164.537 369.098C163.382 369.579 162.112 369.703 160.887 369.456C159.662 369.209 158.537 368.601 157.655 367.71C156.772 366.818 156.171 365.682 155.928 364.446C155.685 363.21 155.811 361.929 156.29 360.765C156.768 359.601 157.578 358.606 158.617 357.906C159.656 357.207 160.877 356.833 162.126 356.833C162.956 356.833 163.779 356.998 164.546 357.319C165.313 357.64 166.01 358.111 166.597 358.703C167.184 359.296 167.649 360 167.966 360.775C168.283 361.549 168.445 362.379 168.444 363.217Z"
                  fill="white"
                />
                <path
                  d="M297.333 382.732C297.333 383.466 297.117 384.184 296.713 384.793C296.31 385.403 295.736 385.878 295.066 386.158C294.396 386.438 293.659 386.511 292.947 386.368C292.236 386.226 291.582 385.873 291.069 385.355C290.555 384.837 290.205 384.176 290.063 383.456C289.921 382.736 289.994 381.99 290.272 381.312C290.551 380.634 291.022 380.056 291.625 379.649C292.229 379.242 292.938 379.025 293.663 379.025C294.635 379.025 295.568 379.415 296.256 380.11C296.945 380.804 297.333 381.748 297.333 382.732Z"
                  fill="white"
                  stroke="#CA8BE9"
                />
              </g>
              <g className="circle">
                <path
                  opacity="0.5"
                  d="M299.959 382.732C299.957 383.992 299.585 385.224 298.889 386.27C298.194 387.317 297.206 388.132 296.052 388.613C294.897 389.094 293.627 389.219 292.402 388.971C291.177 388.724 290.052 388.117 289.17 387.225C288.287 386.333 287.686 385.197 287.443 383.961C287.2 382.725 287.326 381.444 287.805 380.28C288.283 379.116 289.093 378.122 290.132 377.422C291.171 376.722 292.392 376.348 293.641 376.348C294.472 376.348 295.294 376.513 296.061 376.834C296.829 377.155 297.526 377.626 298.112 378.219C298.699 378.812 299.164 379.516 299.481 380.29C299.798 381.065 299.961 381.894 299.959 382.732Z"
                  fill="white"
                />
                <path
                  d="M387.273 248.672C387.273 249.406 387.057 250.123 386.653 250.733C386.249 251.342 385.676 251.817 385.005 252.097C384.335 252.377 383.598 252.45 382.887 252.308C382.176 252.165 381.522 251.813 381.008 251.294L380.653 251.646L381.008 251.294C380.495 250.776 380.144 250.116 380.002 249.396C379.86 248.676 379.933 247.93 380.212 247.252C380.49 246.574 380.961 245.995 381.565 245.588C382.168 245.182 382.877 244.965 383.602 244.965C384.574 244.965 385.507 245.354 386.196 246.049C386.885 246.744 387.273 247.687 387.273 248.672Z"
                  fill="white"
                  stroke="#CA8BE9"
                />
              </g>
              <g className="circle">
                <path
                  opacity="0.5"
                  d="M389.899 248.672C389.897 249.932 389.524 251.163 388.829 252.21C388.133 253.256 387.146 254.072 385.991 254.552C384.836 255.033 383.566 255.158 382.341 254.911C381.117 254.664 379.992 254.056 379.109 253.164C378.227 252.272 377.626 251.137 377.383 249.901C377.14 248.665 377.266 247.384 377.744 246.22C378.223 245.056 379.033 244.061 380.071 243.361C381.11 242.661 382.331 242.288 383.58 242.288C384.411 242.288 385.234 242.453 386.001 242.774C386.768 243.095 387.465 243.565 388.052 244.158C388.639 244.751 389.104 245.455 389.421 246.229C389.738 247.004 389.9 247.834 389.899 248.672Z"
                  fill="white"
                />
                <path
                  d="M395.545 356.752C397.42 356.752 398.939 355.232 398.939 353.358C398.939 351.483 397.42 349.964 395.545 349.964C393.671 349.964 392.151 351.483 392.151 353.358C392.151 355.232 393.671 356.752 395.545 356.752Z"
                  fill="white"
                  stroke="#CA8BE9"
                />
              </g>
              <path
                className="circle"
                d="M317.909 432.861C319.783 432.861 321.303 431.341 321.303 429.467C321.303 427.592 319.783 426.073 317.909 426.073C316.035 426.073 314.515 427.592 314.515 429.467C314.515 431.341 316.035 432.861 317.909 432.861Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M196.363 439.581C196.363 440.315 196.148 441.032 195.744 441.642C195.34 442.252 194.766 442.726 194.096 443.006C193.426 443.286 192.689 443.359 191.978 443.217C191.267 443.074 190.613 442.722 190.099 442.204C189.585 441.686 189.235 441.025 189.093 440.305C188.951 439.585 189.024 438.839 189.302 438.161C189.581 437.483 190.052 436.904 190.655 436.498C191.259 436.091 191.968 435.874 192.693 435.874C193.665 435.874 194.598 436.264 195.287 436.958C195.976 437.653 196.363 438.596 196.363 439.581Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <g className="circle">
                <path
                  opacity="0.5"
                  d="M198.99 439.581C198.987 440.841 198.615 442.072 197.92 443.119C197.224 444.166 196.237 444.981 195.082 445.462C193.927 445.942 192.657 446.067 191.432 445.82C190.207 445.573 189.083 444.965 188.2 444.073C187.317 443.182 186.717 442.046 186.474 440.81C186.231 439.574 186.356 438.293 186.835 437.129C187.313 435.965 188.123 434.97 189.162 434.27C190.201 433.57 191.422 433.197 192.671 433.197C193.502 433.197 194.324 433.362 195.092 433.683C195.859 434.004 196.556 434.474 197.143 435.067C197.729 435.66 198.195 436.364 198.512 437.139C198.828 437.913 198.991 438.743 198.99 439.581Z"
                  fill="white"
                />
                <path
                  d="M226.952 447.964C228.826 447.964 230.345 446.444 230.345 444.57C230.345 442.695 228.826 441.176 226.952 441.176C225.077 441.176 223.558 442.695 223.558 444.57C223.558 446.444 225.077 447.964 226.952 447.964Z"
                  fill="white"
                  stroke="#CA8BE9"
                />
              </g>
              <path
                className="circle"
                d="M127.509 421.491C129.384 421.491 130.903 419.971 130.903 418.097C130.903 416.222 129.384 414.703 127.509 414.703C125.635 414.703 124.115 416.222 124.115 418.097C124.115 419.971 125.635 421.491 127.509 421.491Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M74.8183 371.43C76.6927 371.43 78.2122 369.911 78.2122 368.036C78.2122 366.162 76.6927 364.642 74.8183 364.642C72.9438 364.642 71.4243 366.162 71.4243 368.036C71.4243 369.911 72.9438 371.43 74.8183 371.43Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M50.7211 341.139C52.5955 341.139 54.115 339.62 54.115 337.745C54.115 335.871 52.5955 334.351 50.7211 334.351C48.8467 334.351 47.3271 335.871 47.3271 337.745C47.3271 339.62 48.8467 341.139 50.7211 341.139Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M20.515 250.012C22.3895 250.012 23.909 248.493 23.909 246.618C23.909 244.744 22.3895 243.224 20.515 243.224C18.6406 243.224 17.1211 244.744 17.1211 246.618C17.1211 248.493 18.6406 250.012 20.515 250.012Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M42.1513 158.206C44.0257 158.206 45.5452 156.686 45.5452 154.812C45.5452 152.938 44.0257 151.418 42.1513 151.418C40.2768 151.418 38.7573 152.938 38.7573 154.812C38.7573 156.686 40.2768 158.206 42.1513 158.206Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M57.933 144.036C59.8074 144.036 61.3269 142.517 61.3269 140.642C61.3269 138.768 59.8074 137.248 57.933 137.248C56.0586 137.248 54.5391 138.768 54.5391 140.642C54.5391 142.517 56.0586 144.036 57.933 144.036Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M52.9271 137.079C54.8016 137.079 56.3211 135.559 56.3211 133.685C56.3211 131.81 54.8016 130.291 52.9271 130.291C51.0527 130.291 49.5332 131.81 49.5332 133.685C49.5332 135.559 51.0527 137.079 52.9271 137.079Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M135.909 53.2485C137.784 53.2485 139.303 51.7289 139.303 49.8545C139.303 47.9801 137.784 46.4606 135.909 46.4606C134.035 46.4606 132.515 47.9801 132.515 49.8545C132.515 51.7289 134.035 53.2485 135.909 53.2485Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M228.055 35.006C229.929 35.006 231.449 33.4865 231.449 31.6121C231.449 29.7377 229.929 28.2181 228.055 28.2181C226.18 28.2181 224.661 29.7377 224.661 31.6121C224.661 33.4865 226.18 35.006 228.055 35.006Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M270.903 43.6606C272.777 43.6606 274.297 42.141 274.297 40.2666C274.297 38.3922 272.777 36.8727 270.903 36.8727C269.028 36.8727 267.509 38.3922 267.509 40.2666C267.509 42.141 269.028 43.6606 270.903 43.6606Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M192.588 102.036C194.134 102.036 195.388 100.783 195.388 99.2363C195.388 97.6899 194.134 96.4363 192.588 96.4363C191.041 96.4363 189.788 97.6899 189.788 99.2363C189.788 100.783 191.041 102.036 192.588 102.036Z"
                fill="white"
                stroke="#D76FFC"
              />
              <path
                className="circle"
                d="M105.024 169.236C106.571 169.236 107.824 167.983 107.824 166.436C107.824 164.89 106.571 163.636 105.024 163.636C103.478 163.636 102.224 164.89 102.224 166.436C102.224 167.983 103.478 169.236 105.024 169.236Z"
                fill="white"
                stroke="#D76FFC"
              />
              <path
                className="circle"
                d="M70.5759 304.909C72.1223 304.909 73.3759 303.655 73.3759 302.109C73.3759 300.563 72.1223 299.309 70.5759 299.309C69.0295 299.309 67.7759 300.563 67.7759 302.109C67.7759 303.655 69.0295 304.909 70.5759 304.909Z"
                fill="white"
                stroke="#D76FFC"
              />
              <path
                className="circle"
                d="M139.727 385.006C141.274 385.006 142.527 383.752 142.527 382.206C142.527 380.66 141.274 379.406 139.727 379.406C138.181 379.406 136.927 380.66 136.927 382.206C136.927 383.752 138.181 385.006 139.727 385.006Z"
                fill="white"
                stroke="#D76FFC"
              />
              <path
                className="circle"
                d="M303.485 339.103C305.031 339.103 306.285 337.849 306.285 336.303C306.285 334.757 305.031 333.503 303.485 333.503C301.938 333.503 300.685 334.757 300.685 336.303C300.685 337.849 301.938 339.103 303.485 339.103Z"
                fill="white"
                stroke="#D76FFC"
              />
              <path
                className="circle"
                d="M356.43 177.551C357.977 177.551 359.23 176.298 359.23 174.751C359.23 173.205 357.977 171.951 356.43 171.951C354.884 171.951 353.63 173.205 353.63 174.751C353.63 176.298 354.884 177.551 356.43 177.551Z"
                fill="white"
                stroke="#D76FFC"
              />
              <path
                className="circle"
                d="M254.782 155.321C256.047 155.321 257.073 154.296 257.073 153.03C257.073 151.765 256.047 150.739 254.782 150.739C253.516 150.739 252.491 151.765 252.491 153.03C252.491 154.296 253.516 155.321 254.782 155.321Z"
                fill="white"
                stroke="#D76FFC"
              />
              <path
                className="circle"
                d="M170.103 213.273C171.368 213.273 172.394 212.247 172.394 210.982C172.394 209.717 171.368 208.691 170.103 208.691C168.838 208.691 167.812 209.717 167.812 210.982C167.812 212.247 168.838 213.273 170.103 213.273Z"
                fill="white"
                stroke="#D76FFC"
              />
              <path
                className="circle"
                d="M157.545 301.006C158.811 301.006 159.836 299.98 159.836 298.715C159.836 297.45 158.811 296.424 157.545 296.424C156.28 296.424 155.254 297.45 155.254 298.715C155.254 299.98 156.28 301.006 157.545 301.006Z"
                fill="white"
                stroke="#D76FFC"
              />
              <path
                className="circle"
                d="M299.242 267.406C300.507 267.406 301.533 266.38 301.533 265.115C301.533 263.85 300.507 262.824 299.242 262.824C297.977 262.824 296.951 263.85 296.951 265.115C296.951 266.38 297.977 267.406 299.242 267.406Z"
                fill="white"
                stroke="#D76FFC"
              />
              <path
                className="circle"
                d="M338.952 68.5212C340.826 68.5212 342.345 67.0016 342.345 65.1272C342.345 63.2528 340.826 61.7333 338.952 61.7333C337.077 61.7333 335.558 63.2528 335.558 65.1272C335.558 67.0016 337.077 68.5212 338.952 68.5212Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M395.885 125.2C397.759 125.2 399.279 123.68 399.279 121.806C399.279 119.932 397.759 118.412 395.885 118.412C394.01 118.412 392.491 119.932 392.491 121.806C392.491 123.68 394.01 125.2 395.885 125.2Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M373.4 133.6C375.274 133.6 376.794 132.08 376.794 130.206C376.794 128.332 375.274 126.812 373.4 126.812C371.525 126.812 370.006 128.332 370.006 130.206C370.006 132.08 371.525 133.6 373.4 133.6Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M437.715 253.321C439.59 253.321 441.109 251.802 441.109 249.927C441.109 248.053 439.59 246.533 437.715 246.533C435.841 246.533 434.321 248.053 434.321 249.927C434.321 251.802 435.841 253.321 437.715 253.321Z"
                fill="white"
                stroke="#CA8BE9"
              />
              <path
                className="circle"
                d="M413.024 152.861C414.899 152.861 416.418 151.341 416.418 149.467C416.418 147.592 414.899 146.073 413.024 146.073C411.15 146.073 409.63 147.592 409.63 149.467C409.63 151.341 411.15 152.861 413.024 152.861Z"
                fill="white"
                stroke="#CA8BE9"
              />
            </g>

            <g transform="translate(0 -16)" className="block_icon">
              <path
                opacity="0.65"
                d="M165.947 169.895C189.114 169.895 207.895 151.114 207.895 127.947C207.895 104.78 189.114 86 165.947 86C142.78 86 124 104.78 124 127.947C124 151.114 142.78 169.895 165.947 169.895Z"
                fill="url(#paint0_radial_2382_15879)"
              />
              <path
                d="M199.958 127.947C199.958 146.731 184.731 161.958 165.948 161.958C147.164 161.958 131.937 146.731 131.937 127.947C131.937 109.163 147.164 93.9362 165.948 93.9362C184.731 93.9362 199.958 109.163 199.958 127.947Z"
                fill="#444052"
                fillOpacity="0.5"
                stroke="#D76FFC"
                strokeWidth="1.2191"
              />
              <path
                d="M177.72 117.933C177.289 113.718 173.643 112.329 169.046 111.956L169.013 106.108L165.456 106.132L165.488 111.826C164.554 111.834 163.596 111.858 162.646 111.883L162.613 106.149L159.056 106.165L159.089 112.013C158.317 112.029 157.562 112.053 156.823 112.053V112.037L151.917 112.061L151.941 115.862C151.941 115.862 154.573 115.797 154.524 115.846C155.962 115.838 156.441 116.674 156.579 117.397L156.619 124.057C156.717 124.057 156.847 124.057 156.993 124.082C156.871 124.082 156.749 124.082 156.619 124.082L156.668 133.413C156.611 133.868 156.343 134.591 155.336 134.599C155.385 134.64 152.745 134.615 152.745 134.615L152.063 138.871L156.693 138.847C157.554 138.847 158.406 138.855 159.235 138.855L159.267 144.768L162.825 144.751L162.792 138.904C163.767 138.92 164.717 138.92 165.635 138.912L165.667 144.735L169.225 144.711L169.192 138.806C175.17 138.433 179.352 136.898 179.84 131.277C180.238 126.754 178.093 124.748 174.69 123.952C176.762 122.871 178.037 121.012 177.72 117.933ZM172.814 130.603C172.839 135.022 165.269 134.567 162.857 134.575L162.816 126.737C165.229 126.729 172.79 125.99 172.814 130.603ZM171.093 119.558C171.117 123.578 164.798 123.148 162.792 123.156L162.751 116.049C164.766 116.041 171.068 115.367 171.093 119.558Z"
                fill="white"
              />
            </g>

            <g transform="translate(-3 -4)" className="block_icon">
              <path
                opacity="0.65"
                d="M344.363 96.7263C360.58 96.7263 373.726 83.58 373.726 67.3632C373.726 51.1463 360.58 38 344.363 38C328.146 38 315 51.1463 315 67.3632C315 83.58 328.146 96.7263 344.363 96.7263Z"
                fill="url(#paint1_radial_2382_15879)"
              />
              <path
                d="M367.988 67.363C367.988 80.4106 357.411 90.9877 344.363 90.9877C331.316 90.9877 320.738 80.4106 320.738 67.363C320.738 54.3154 331.316 43.7382 344.363 43.7382C357.411 43.7382 367.988 54.3154 367.988 67.363Z"
                fill="#444052"
                fillOpacity="0.5"
                stroke="#D76FFC"
                strokeWidth="1.2191"
              />
              <path
                d="M334.27 59.7039V75.9994L344.844 79.7993V63.3653L356.292 59.1499L345.904 55.4343L334.27 59.7039Z"
                fill="white"
              />
              <path
                d="M345.711 63.8349V72.7475L356.292 76.5413V59.9207L345.711 63.8349Z"
                fill="white"
              />
            </g>

            <g transform="translate(12 0)" className="block_icon">
              <path
                opacity="0.65"
                d="M215.558 67.1158C234.091 67.1158 249.116 52.0914 249.116 33.5579C249.116 15.0244 234.091 0 215.558 0C197.024 0 182 15.0244 182 33.5579C182 52.0914 197.024 67.1158 215.558 67.1158Z"
                fill="url(#paint2_radial_2382_15879)"
              />
              <path
                d="M242.644 33.5579C242.644 48.5176 230.517 60.6447 215.558 60.6447C200.598 60.6447 188.471 48.5176 188.471 33.5579C188.471 18.5983 200.598 6.47112 215.558 6.47112C230.517 6.47112 242.644 18.5983 242.644 33.5579Z"
                fill="#444052"
                fillOpacity="0.5"
                stroke="#D76FFC"
                strokeWidth="1.2191"
              />
              <path
                d="M209.038 30.88L215.552 24.3657L222.073 30.8861L225.866 27.0928L215.552 16.7791L205.245 27.0867L209.038 30.88ZM198.779 33.5519L202.573 29.7585L206.366 33.5519L202.573 37.3452L198.779 33.5519ZM209.038 36.2299L215.552 42.7442L222.073 36.2238L225.866 40.011L215.552 50.3248L205.245 40.0171L205.238 40.011L209.038 36.2299ZM224.751 33.558L228.544 29.7647L232.337 33.558L228.544 37.3514L224.751 33.558Z"
                fill="white"
              />
              <path
                d="M219.4 33.552L215.552 29.7035L212.708 32.547L212.383 32.8718L211.709 33.5459L211.703 33.552L211.709 33.5581L215.552 37.4005L219.4 33.552Z"
                fill="white"
              />
            </g>

            <g transform="translate(-2 2)" className="block_icon">
              <path
                opacity="0.65"
                d="M54.3632 161.726C70.58 161.726 83.7264 148.58 83.7264 132.363C83.7264 116.146 70.58 103 54.3632 103C38.1463 103 25 116.146 25 132.363C25 148.58 38.1463 161.726 54.3632 161.726Z"
                fill="url(#paint3_radial_2382_15879)"
              />
              <path
                d="M77.988 132.363C77.988 145.411 67.4108 155.988 54.3632 155.988C41.3156 155.988 30.7385 145.411 30.7385 132.363C30.7385 119.315 41.3156 108.738 54.3632 108.738C67.4108 108.738 77.988 119.315 77.988 132.363Z"
                fill="#444052"
                fillOpacity="0.5"
                stroke="#D76FFC"
                strokeWidth="1.2191"
              />
              <path
                d="M54.2863 128.704L39.6816 143.753L54.3632 120.434L69.0448 143.895L54.2863 128.704Z"
                fill="white"
              />
              <path
                d="M56.4174 134.695H51.8353L54.1856 132.168L56.4174 134.707V134.695ZM47.6085 138.839H60.7627L58.0928 136.17L50.1896 136.193V136.205L47.6025 138.792"
                fill="white"
              />
            </g>

            <g transform="translate(0 -8)" className="block_icon">
              <path
                opacity="0.65"
                d="M25.1684 276.337C39.0686 276.337 50.3369 265.069 50.3369 251.168C50.3369 237.268 39.0686 226 25.1684 226C11.2683 226 0 237.268 0 251.168C0 265.069 11.2683 276.337 25.1684 276.337Z"
                fill="url(#paint4_radial_2382_15879)"
              />
              <path
                d="M45.3305 251.168C45.3305 262.304 36.3033 271.331 25.1678 271.331C14.0322 271.331 5.00506 262.304 5.00506 251.168C5.00506 240.033 14.0322 231.006 25.1678 231.006C36.3033 231.006 45.3305 240.033 45.3305 251.168Z"
                fill="#444052"
                fillOpacity="0.5"
                stroke="#D76FFC"
                strokeWidth="1.2191"
              />
              <path
                d="M25.21 238.233L25.0312 238.844V256.551L25.21 256.729L33.4327 251.873L25.21 238.233Z"
                fill="#EDEEEF"
              />
              <path
                d="M25.2099 238.233L16.9922 251.873L25.2099 256.729V248.134V238.233Z"
                fill="white"
              />
              <path
                d="M25.2097 258.284L25.1104 258.408V264.714L25.2097 265.012L33.4373 253.427L25.2097 258.284Z"
                fill="#EDEEEF"
              />
              <path
                d="M25.2099 265.012V258.284L16.9922 253.427L25.2099 265.012Z"
                fill="white"
              />
              <path
                d="M33.4326 251.873L25.21 256.729V248.134L33.4326 251.873Z"
                fill="#D5D8DB"
              />
              <path
                d="M25.2099 248.134V256.729L16.9922 251.873L25.2099 248.134Z"
                fill="#EDEEEF"
              />
            </g>

            <g className="block_icon">
              <path
                opacity="0.65"
                d="M75.5579 398.116C94.0915 398.116 109.116 383.091 109.116 364.558C109.116 346.024 94.0915 331 75.5579 331C57.0244 331 42 346.024 42 364.558C42 383.091 57.0244 398.116 75.5579 398.116Z"
                fill="url(#paint5_radial_2382_15879)"
              />
              <path
                d="M102.644 364.558C102.644 379.517 90.5173 391.645 75.5577 391.645C60.5981 391.645 48.4709 379.517 48.4709 364.558C48.4709 349.598 60.5981 337.471 75.5577 337.471C90.5173 337.471 102.644 349.598 102.644 364.558Z"
                fill="#444052"
                fillOpacity="0.5"
                stroke="#D76FFC"
                strokeWidth="1.2191"
              />
              <path
                d="M83.1852 352.598C84.2067 352.598 85.0397 351.753 85.0397 350.713C85.0397 349.673 84.2067 348.828 83.1852 348.828C82.1637 348.834 81.3307 349.679 81.3307 350.719C81.3307 351.759 82.1637 352.598 83.1852 352.598ZM83.7324 357.493C84.608 357.486 85.3133 356.769 85.3073 355.893C85.3073 355.018 84.6019 354.294 83.7324 354.294C82.8629 354.294 82.1576 355.006 82.1576 355.893C82.1637 356.781 82.8629 357.493 83.7324 357.493ZM88.0495 358.119C88.913 358.119 89.6183 357.407 89.6183 356.526C89.6183 355.644 88.913 354.933 88.0495 354.933C87.1861 354.933 86.4808 355.644 86.4808 356.526C86.4808 357.407 87.1861 358.119 88.0495 358.119ZM87.5327 362.308C88.2745 362.308 88.8765 361.7 88.8765 360.946C88.8765 360.198 88.2745 359.584 87.5327 359.584C86.7909 359.584 86.1889 360.192 86.1889 360.946C86.1889 361.7 86.7909 362.308 87.5327 362.308ZM90.9864 363.67C91.7343 363.67 92.3362 363.056 92.3362 362.302C92.3362 361.548 91.7343 360.934 90.9864 360.934C90.2324 360.94 89.6304 361.554 89.6365 362.302C89.6365 363.056 90.2446 363.67 90.9864 363.67ZM83.1913 361.743C83.9574 361.737 84.5715 361.116 84.5654 360.35C84.5654 359.578 83.9513 358.958 83.1913 358.958C82.4312 358.958 81.8171 359.578 81.8171 360.35C81.811 361.116 82.4312 361.743 83.1913 361.743ZM81.9448 365.075C82.5832 365.075 83.094 364.552 83.094 363.907C83.1001 363.269 82.5832 362.746 81.9448 362.74H81.9387C81.3003 362.74 80.7895 363.263 80.7895 363.907C80.7895 364.552 81.3063 365.075 81.9448 365.075ZM86.268 365.665C86.9003 365.659 87.4172 365.142 87.4111 364.503C87.4111 363.859 86.9003 363.342 86.268 363.342C85.6356 363.342 85.1248 363.859 85.1248 364.503C85.1188 365.136 85.6234 365.659 86.2558 365.665H86.268ZM89.7095 367.021C90.3479 367.021 90.8587 366.498 90.8587 365.847C90.8587 365.196 90.3419 364.673 89.7095 364.673C89.071 364.673 88.5603 365.196 88.5603 365.847C88.5542 366.485 89.065 367.014 89.7095 367.021ZM88.007 369.55C88.5481 369.55 88.9799 369.106 88.9799 368.565C88.9799 368.024 88.5421 367.58 88.007 367.58C87.4658 367.58 87.0341 368.024 87.0341 368.565C87.0341 369.106 87.4719 369.55 88.007 369.55ZM84.5472 368.218C85.0944 368.218 85.5444 367.762 85.5444 367.209C85.5444 366.65 85.1005 366.2 84.5472 366.2C83.9939 366.2 83.55 366.656 83.55 367.209C83.55 367.762 84 368.218 84.5472 368.218ZM80.2301 367.598C80.7834 367.592 81.2273 367.136 81.2151 366.583C81.2091 366.042 80.7713 365.604 80.2301 365.598C79.6768 365.604 79.2329 366.06 79.2451 366.613C79.2511 367.154 79.6889 367.592 80.2301 367.598ZM82.6319 369.976C83.1061 369.976 83.4892 369.586 83.4892 369.106C83.4953 368.632 83.1122 368.243 82.638 368.237H82.6319C82.1576 368.237 81.7745 368.626 81.7745 369.106C81.7685 369.58 82.1515 369.97 82.6258 369.976H82.6319ZM86.0916 371.332C86.5659 371.332 86.9611 370.942 86.9611 370.456C86.9611 369.97 86.572 369.58 86.0916 369.58C85.6052 369.58 85.2161 369.976 85.2161 370.456C85.2161 370.936 85.6052 371.332 86.0916 371.332ZM84.1398 372.347C84.5168 372.347 84.8269 372.037 84.8269 371.654C84.8269 371.271 84.5229 370.961 84.1398 370.961C83.7628 370.961 83.4527 371.271 83.4527 371.654C83.4588 372.031 83.7628 372.341 84.1398 372.347ZM82.2914 372.894C82.6379 372.894 82.9116 372.615 82.9116 372.268C82.9116 371.921 82.6319 371.642 82.2914 371.642C81.9448 371.642 81.6712 371.921 81.6712 372.268C81.6651 372.608 81.9387 372.888 82.2792 372.894H82.2914ZM80.674 371.082C81.0814 371.082 81.4097 370.748 81.4097 370.334C81.4097 369.921 81.0814 369.586 80.674 369.586C80.2666 369.586 79.9382 369.921 79.9382 370.334C79.9382 370.748 80.2666 371.082 80.674 371.082ZM78.3026 369.374C78.7769 369.374 79.1599 368.985 79.1599 368.504C79.1599 368.024 78.7769 367.635 78.3026 367.635C77.8283 367.635 77.4453 368.024 77.4453 368.504C77.4453 368.978 77.8283 369.368 78.3026 369.374ZM85.3437 380.258C86.3653 380.258 87.1922 379.419 87.1922 378.385C87.1922 377.351 86.3653 376.512 85.3437 376.512C84.3222 376.512 83.4953 377.351 83.4953 378.385C83.4953 379.419 84.3222 380.258 85.3437 380.258ZM80.6496 377.88C81.5009 377.88 82.188 377.181 82.188 376.318C82.188 375.454 81.5009 374.755 80.6496 374.755C79.7984 374.755 79.1113 375.454 79.1113 376.318C79.1113 377.181 79.7984 377.88 80.6496 377.88ZM77.9682 381.316C78.8255 381.316 79.5187 380.61 79.5187 379.741C79.5187 378.871 78.8255 378.166 77.9682 378.166C77.1108 378.166 76.4177 378.871 76.4177 379.741C76.4055 380.604 77.1048 381.31 77.9682 381.316ZM77.1595 374.986C77.9074 374.98 78.5093 374.372 78.5033 373.618C78.5093 372.87 77.9074 372.256 77.1595 372.25C76.4116 372.256 75.8096 372.864 75.8157 373.618C75.8157 374.372 76.4177 374.986 77.1595 374.986ZM74.4841 378.47C75.2259 378.47 75.8279 377.862 75.8279 377.108C75.8279 376.36 75.2259 375.746 74.4841 375.746C73.7423 375.746 73.1403 376.354 73.1403 377.108C73.1342 377.85 73.7301 378.458 74.4719 378.47H74.4841ZM71.602 380.835C72.3438 380.835 72.9397 380.227 72.9397 379.479C72.9397 378.731 72.3377 378.123 71.602 378.123C70.8601 378.123 70.2643 378.731 70.2643 379.479C70.2643 380.221 70.8662 380.835 71.602 380.835ZM69.2063 377.759C69.8386 377.753 70.3494 377.236 70.3494 376.603C70.3494 375.965 69.8386 375.448 69.2063 375.448C68.5678 375.46 68.0571 375.983 68.0692 376.622C68.0753 377.242 68.58 377.746 69.2063 377.759ZM72.0945 375.381C72.7268 375.375 73.2437 374.858 73.2376 374.226C73.2376 373.581 72.7268 373.071 72.0945 373.071C71.456 373.077 70.9453 373.606 70.9514 374.244C70.9574 374.87 71.4621 375.375 72.0945 375.381ZM74.7881 371.903C75.4205 371.897 75.9373 371.38 75.9312 370.742C75.9312 370.097 75.4205 369.58 74.7881 369.58C74.1557 369.586 73.6389 370.103 73.645 370.736C73.645 371.38 74.1557 371.903 74.7881 371.903ZM70.6656 372.383C71.2128 372.383 71.6567 371.934 71.6567 371.38C71.6567 370.827 71.2128 370.377 70.6656 370.377C70.1183 370.377 69.6745 370.827 69.6745 371.38C69.6745 371.934 70.1183 372.383 70.6656 372.383ZM67.7895 374.749C68.3368 374.749 68.7746 374.299 68.7746 373.758C68.7806 373.21 68.3428 372.767 67.7956 372.76H67.7895C67.2423 372.76 66.8045 373.21 66.8045 373.752C66.8045 374.299 67.2484 374.743 67.7895 374.749ZM67.1328 371.976C67.6071 371.97 67.9841 371.587 67.9841 371.119C67.9841 370.644 67.601 370.261 67.1328 370.261C66.6646 370.261 66.2816 370.651 66.2816 371.119C66.2816 371.593 66.6646 371.976 67.1328 371.976ZM67.1085 369.544C67.5159 369.538 67.8382 369.21 67.8382 368.802C67.8382 368.395 67.5098 368.06 67.1085 368.06C66.7072 368.06 66.3789 368.389 66.3789 368.802C66.3789 369.216 66.7072 369.544 67.1085 369.544ZM67.5098 367.519C67.8564 367.519 68.13 367.233 68.13 366.893C68.13 366.546 67.8503 366.267 67.5098 366.267C67.1632 366.267 66.8896 366.552 66.8896 366.893C66.8896 367.239 67.1632 367.519 67.5098 367.519ZM69.9846 367.185C70.392 367.185 70.7203 366.85 70.7203 366.437C70.7203 366.023 70.392 365.689 69.9846 365.689C69.5772 365.689 69.2488 366.023 69.2488 366.437C69.2488 366.844 69.5772 367.179 69.9846 367.185ZM72.7025 366.121C73.1768 366.121 73.5599 365.731 73.5599 365.251C73.5659 364.777 73.1829 364.388 72.7086 364.382H72.7025C72.2282 364.382 71.8452 364.771 71.8452 365.251C71.8391 365.731 72.2222 366.121 72.7025 366.121ZM73.3531 368.881C73.8943 368.881 74.326 368.443 74.326 367.902C74.326 367.361 73.8882 366.929 73.347 366.929C72.8059 366.929 72.3742 367.367 72.3742 367.908C72.3742 368.443 72.812 368.881 73.3531 368.881ZM70.021 369.617C70.4953 369.617 70.8723 369.228 70.8723 368.753C70.8723 368.273 70.4892 367.89 70.021 367.89C69.5468 367.89 69.1698 368.279 69.1698 368.747V368.753C69.1637 369.222 69.5407 369.611 70.0089 369.617H70.021ZM60.6207 368.334C61.6361 368.334 62.4631 367.495 62.4631 366.467C62.4631 365.44 61.6361 364.601 60.6207 364.601C59.6053 364.601 58.7783 365.44 58.7783 366.467C58.7783 367.501 59.6053 368.334 60.6207 368.334ZM64.804 365.002C65.6796 365.002 66.3789 364.284 66.3789 363.403C66.3789 362.521 65.6675 361.804 64.804 361.804C63.9285 361.81 63.2231 362.527 63.2292 363.403C63.2231 364.29 63.9345 365.002 64.804 365.002ZM63.1684 360.891C64.0379 360.891 64.7371 360.18 64.7371 359.298C64.7371 358.417 64.0318 357.705 63.1684 357.705C62.2989 357.711 61.5936 358.423 61.5996 359.292C61.5936 360.162 62.2867 360.873 63.1623 360.885H63.1684V360.891ZM67.1997 358.946C67.9415 358.946 68.5435 358.338 68.5435 357.578C68.5435 356.824 67.9415 356.21 67.1997 356.21C66.4579 356.21 65.8559 356.818 65.8559 357.578C65.8559 358.338 66.4579 358.946 67.1997 358.946ZM68.8475 363.044C69.5954 363.044 70.1974 362.43 70.1974 361.676C70.1974 360.922 69.5954 360.308 68.8475 360.308C68.0996 360.308 67.4977 360.922 67.4977 361.676C67.4977 362.43 68.0996 363.044 68.8475 363.044ZM72.5201 362.193C73.1586 362.187 73.6754 361.664 73.6693 361.025C73.6815 360.393 73.1707 359.87 72.5383 359.858C71.906 359.846 71.3831 360.356 71.3709 360.989C71.3709 361.001 71.3709 361.013 71.3709 361.025C71.3648 361.664 71.8756 362.187 72.5079 362.193H72.5201ZM75.688 362.205C76.2352 362.205 76.6791 361.755 76.6791 361.202C76.6791 360.648 76.2352 360.198 75.688 360.198C75.1347 360.198 74.6847 360.648 74.6847 361.202C74.6847 361.755 75.1347 362.205 75.688 362.205ZM78.3026 362.807C78.7586 362.807 79.1417 362.43 79.1417 361.962C79.1417 361.493 78.7708 361.116 78.3026 361.116C77.8405 361.123 77.4635 361.5 77.4635 361.962C77.4757 362.424 77.8466 362.807 78.3026 362.807ZM78.6431 359.724C79.0505 359.724 79.3728 359.39 79.3728 358.988C79.3728 358.581 79.0444 358.253 78.6431 358.253C78.2418 358.253 77.9135 358.581 77.9135 358.988C77.9135 359.39 78.2418 359.718 78.6431 359.724ZM76.6305 358.715C77.0926 358.715 77.4696 358.338 77.4696 357.876C77.4696 357.413 77.0926 357.036 76.6305 357.036C76.1684 357.036 75.7914 357.413 75.7914 357.876C75.7914 358.338 76.1623 358.709 76.6305 358.715ZM74.0463 358.101C74.5935 358.094 75.0313 357.651 75.0313 357.103C75.0313 356.55 74.5935 356.106 74.0463 356.106C73.5051 356.106 73.0613 356.556 73.0613 357.103C73.0552 357.651 73.493 358.094 74.0463 358.101C74.0402 358.101 74.0402 358.101 74.0463 358.101ZM70.8784 358.107C71.5168 358.107 72.0276 357.584 72.0276 356.939C72.0276 356.295 71.5108 355.772 70.8784 355.772C70.2399 355.772 69.7292 356.295 69.7292 356.939C69.7292 357.578 70.2399 358.101 70.8784 358.107ZM66.6221 355.188C67.3457 355.188 67.9233 354.598 67.9233 353.862C67.9233 353.133 67.3396 352.543 66.6221 352.543C65.8985 352.543 65.3209 353.133 65.3209 353.862C65.3148 354.598 65.9046 355.188 66.6221 355.188ZM70.2886 354.385C70.927 354.385 71.4378 353.862 71.4378 353.218C71.4378 352.573 70.921 352.051 70.2886 352.051C69.6501 352.051 69.1394 352.573 69.1394 353.218C69.1333 353.862 69.6501 354.385 70.2886 354.385ZM73.4565 354.398C74.0037 354.398 74.4476 353.948 74.4476 353.394C74.4476 352.835 74.0037 352.391 73.4565 352.391C72.9032 352.391 72.4593 352.841 72.4654 353.394C72.4593 353.948 72.9032 354.398 73.4565 354.398ZM76.0528 355C76.515 355 76.8919 354.623 76.8919 354.154C76.8919 353.686 76.521 353.309 76.0528 353.309C75.5846 353.309 75.2077 353.686 75.2077 354.154C75.2077 354.623 75.5846 355 76.0528 355ZM78.0472 356.033C78.4607 356.033 78.7951 355.693 78.7951 355.279C78.7951 354.86 78.4607 354.525 78.0472 354.525C77.6338 354.525 77.2993 354.866 77.2993 355.279C77.3054 355.693 77.6398 356.033 78.0472 356.033ZM79.5126 357.225C79.8531 357.225 80.1267 356.945 80.1267 356.605C80.1267 356.264 79.8531 355.985 79.5126 355.985C79.1721 355.985 78.8985 356.264 78.8985 356.605C78.8924 356.945 79.166 357.225 79.5004 357.225H79.5126Z"
                fill="white"
              />
            </g>

            <defs>
              <radialGradient
                id="paint0_radial_2382_15879"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(165.946 127.946) scale(52.1159)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint1_radial_2382_15879"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(344.362 67.362) scale(36.4811)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint2_radial_2382_15879"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(215.557 33.5566) scale(41.6927)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint3_radial_2382_15879"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(54.362 132.362) scale(36.4811)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint4_radial_2382_15879"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(25.1674 251.167) scale(31.2695)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
              <radialGradient
                id="paint5_radial_2382_15879"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(75.5566 364.557) scale(41.6927)"
              >
                <stop stopColor="#B660E1" />
                <stop offset="0.995" stopColor="#B660E1" stopOpacity="0" />
              </radialGradient>
            </defs>
          </svg>
        </div>
      )}
    </Wrap>
  );
};

export default Blockchain;

const Wrap = styled.div`
  z-index: 6;

  svg {
    position: absolute;
  }
  .zoom_out {
    transition: all 1.5s ease;
    transform: scale(0.5) translate(41%, 322px);
  }

  svg#banner_blockchain {
    top: 10%;
    left: 11%;
    z-index: 5;
  }

  svg#node_sphere {
    top: 10%;
    left: 11%;
    width: 64%;
    height: auto;
    z-index: 0;
  }

  .content .line {
    opacity: 0.6;
  }

  .lines .line {
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
  }

  .circles .circle,
  .block_icon {
    opacity: 0;
    transform-origin: 51% 54%;
  }
`;
